module.exports = __webpack_public_path__ + "05_face.dcb1510b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer1/05_face.png
// module id = keX+
// module chunks = 0